module.exports = __webpack_public_path__ + "static/media/step1-cookies.8365f539.png";